// A tab open across a deploy asks for chunks that are gone. A reload brings the new ones; once, so a real outage does
// not become a reload loop.
const KEY = "filmsquare.chunkReload";
const AGAIN_AFTER_MS = 60_000;

export function reloadForNewChunks(
  e: Pick<Event, "preventDefault">,
  reload: () => void,
  store: Pick<Storage, "getItem" | "setItem"> = sessionStorage,
  now = Date.now(),
): boolean {
  try {
    if (now - Number(store.getItem(KEY) ?? 0) < AGAIN_AFTER_MS) return false;
    store.setItem(KEY, String(now));
  } catch {
    return false; // no storage: nothing to stop a loop with, so the screen shows its error
  }
  e.preventDefault();
  reload();
  return true;
}
